import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MenuInfoService } from '../../../services/menu-info.service';
import { GoogleAnalyticsService } from '../../../services/google-analytics/google-analytics.service';

@Component({
  selector: 'app-documentos',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './documentos.component.html',
  styleUrl: './documentos.component.css',
})
export class DocumentosComponent implements OnInit {
  title: string = 'Documentos';
  documents: any = null;
  tipoDocumentoSeleccionado: string = 'docCondition';
  documentosActuales: any[] = [];
  tipoDocumentoName: string = '';

  constructor(private menuInfoService: MenuInfoService,private gAnalytics: GoogleAnalyticsService) {}

  ngOnInit() {
    this.menuInfoService.getDocuments().subscribe({
      next: (response) => {
        if (response.data) {
          this.documents = response.data;
          this.cambiarTipoDocumento();
        }
      },
      error: (error) => {
        console.error('Error al cargar documentos:', error);
      },
    });
  }

  cambiarTipoDocumento() {
    if (this.documents && this.tipoDocumentoSeleccionado) {
      this.documentosActuales =
        this.documents[this.tipoDocumentoSeleccionado] || [];
      switch (this.tipoDocumentoSeleccionado) {
        case 'docCondition':
          this.tipoDocumentoName = 'Condiciones';
          break;
        case 'docInstructive':
          this.tipoDocumentoName = 'Instructivos';
          break;
        case 'docForm':
          this.tipoDocumentoName = 'Formularios';
          break;
        case 'docProduct':
          this.tipoDocumentoName = 'Productos';
          break;
        case 'docRequirement':
          this.tipoDocumentoName = 'Requisitos';
          break;
    }}

    this.gAnalytics.trackEvent('tipo_documento_seleccionado',{
        page:'/documentos',
        format:this.tipoDocumentoName
      })

  }
}
